export default __webpack_public_path__ + "v1.18.25/static/media/sad-file.c68aeff0.svg";